import $ from 'jquery';

$(document).ready(() => {
    if ($('body').attr('id') !== 'checkout') {
        var $window       = $(window);
        var lastScrollTop = 0;
        var $header       = $('#header-top');
        var $menuSep      = $('#menu-sep');
        var headerHeight  = $header.outerHeight();
        var headerBottom  = $header.position().top + $header.outerHeight(true);
        $window.scroll( function() {
            var windowTop  = $window.scrollTop();
            if (windowTop >= headerBottom) {
                $('body').css('padding-top', headerHeight + 'px');
                $header.addClass('header-sticky');
                $menuSep.removeClass('d-none');
            } else {
                $header.removeClass('header-sticky');
                $header.removeClass('header-sticky-show');
                $menuSep.addClass('d-none');
                $('body').css('padding-top', '0');
            }
            if ($header.hasClass('header-sticky')) {
                if (windowTop <= headerBottom || windowTop < lastScrollTop) {
                $header.addClass('header-sticky-show');
                } else {
                $header.removeClass('header-sticky-show');
                }
            }
            lastScrollTop = windowTop;
        });
    }
});